import { getConfiguration } from "./configuration";

export function getTimezoneOffset() {
	const conf = getConfiguration();
	if (conf.dbutc) {
		let offset = new Date().getTimezoneOffset();
		offset /= -60;
		return offset;	
	}
	
	return 0;
}
